import React from 'react'
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
    button: {
        width:'100%',
        backgroundColor: theme.palette.light.type2,
        color: "white",
        borderColor: theme.palette.light.type2,
        borderRadius: "0 15px 15px 15px",
        cursor:'pointer',
        '&:active': {
            backgroundColor: theme.palette.light.type2,
        },
        '&:hover': {
            backgroundColor: theme.palette.light.type2,
        },
    }
}))



export default function Index({ data, padding, main }) {

    const classes = useStyles()


    return (
        <Button
            variant="contained"
            className={classes.button}
            style={{ padding: padding ? padding : '10px 30px' }}
            href={main ? main : "#" }
            // target="_blank"
        >
            {data}
        </Button>
    )
}
